import React, { Component } from 'react'

class LeftPage extends Component {
  render () {
    return (
      <div className='dashboard-popup-welcome margin-auto'>
        <div>
          <div className='hey-popup-welcome'>
            <div className='hey-popup-header'>
              <div className='header-text'>
                ADIDAS HACKATHON
              </div>
              <a href='https://adidas-hack.com/'><img alt='' src='imgs/close.png' /></a>
            </div>
            <div className='hey-popup-content'>
              <h1>
                YOUR ACCOUNT WAS DELETED <br /> <span className='red'>SUCCESSFULLY.</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LeftPage



// WEBPACK FOOTER //
// ./src/components/users/LeftPage.js